import './DropdownResults.css';
import React from "react";
import { ReactComponent as IconChevronDown } from '../../../../../resources/icons/IconChevronDown.svg';
export const DropdownResults = _ref => {
  let {
    filteredOptions,
    label,
    customClass = '',
    columnsClass = 'col-md-12',
    handleAnalitics
  } = _ref;
  const [isOpen, setisOpen] = React.useState(false);
  const drop = React.useRef();
  const borderRadius = {
    borderRadius: '4px'
  };
  function handleClick(e) {
    if (e.target.closest('.filter__field') !== drop.current && !e.target.closest('.filter-panel__mob-label')) {
      setisOpen(false);
    }
  }
  const toggleFilter = e => {
    setisOpen(!isOpen);
    if (isOpen) {
      document.body.removeEventListener('click', handleClick);
    } else {
      document.body.addEventListener('click', handleClick);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${columnsClass} ${customClass} ${customClass == 'brightcoveHeader__dropdown' ? brightcoveStyles : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field  dropdown-result",
    ref: drop
  }, /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    onClick: toggleFilter,
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`,
    onKeyPress: event => {
      if (event.which === 13 || event.which === 32) {
        event.preventDefault();
        setisOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`,
    style: !isOpen ? borderRadius : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "filter-panel__inner--items"
  }, filteredOptions.map((item, index) => {
    const {
      title,
      url,
      name
    } = item;
    return /*#__PURE__*/React.createElement("li", {
      onClick: () => {
        if (handleAnalitics) {
          handleAnalitics(name);
        }
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      tabIndex: 0,
      "aria-label": title,
      "aria-labelledby": title,
      onKeyPress: event => {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      }
    }, title));
  })))))));
};
const commonStyles = "cssrs8l";
const brightcoveStyles = "brilzib";